import { motion, useScroll, useTransform } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";

const CarruselHorizontal = ({ children }) => {
  const targetRef = useRef(null);
  const containerRef = useRef(null);
  const [scrollRange, setScrollRange] = useState({ start: "0%", end: "0%" });

  const { scrollYProgress } = useScroll({
    target: targetRef,
    offset: ["10% 0%", "80% 80%"],
  });

  const x = useTransform(scrollYProgress, [0, 1], [scrollRange.start, scrollRange.end]);

  useEffect(() => {
    const calculateScrollRange = () => {
      if (!containerRef.current) return;

      const container = containerRef.current;
      const containerWidth = container.offsetWidth;
      const scrollWidth = container.scrollWidth;
      
      // Calcula cuánto debe moverse el contenedor para mostrar todo
      const maxScroll = scrollWidth - window.innerWidth;
      
      // Convierte a porcentaje basado en el ancho del contenedor
      const endPercentage = -(maxScroll / containerWidth) * 100;

      setScrollRange({
        start: "0%",
        end: `${endPercentage}%`,
      });
    };

    // Calcula al montar y al cambiar tamaño
    calculateScrollRange();
    window.addEventListener("resize", calculateScrollRange);

    // Recalcula si cambia el número de children
    const observer = new ResizeObserver(calculateScrollRange);
    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      window.removeEventListener("resize", calculateScrollRange);
      observer.disconnect();
    };
  }, [children]);

  return (
    <div ref={targetRef} className="relative h-[250vh]">
      <div className="sticky top-[20%] pb-40 flex items-center overflow-hidden">
        <motion.div
          ref={containerRef}
          style={{ x }}
          className="flex gap-5"
        >
          {children}
        </motion.div>
      </div>
    </div>
  );
};

export default CarruselHorizontal;